import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	dialogFourteen: 15,
	dialogFifteen: 16,
	dialogSixteen: 17,
	dialogSeventeen: 18,
	dialogEighteen: 19,
	win: 20
};

const stepThree = {

}

export const Theme6SubtopicTwoActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema2], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 2 act 1");
			ObserverEmitter.emit(EVENTS.tema6.topic2.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic1.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic2.initScene, 1);
						ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "reboot_1");
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: (TAE)/Información: Pasos" />
					<DialogBarNew
						dialog={`¡Bien! Es momento de ver uno de nuestros servicios más populares, el Tiempo Aíre Electrónico, (TAE).`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Tiempo Aire Electrónico (TAE)"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Atendamos a nuestra Cliente que solicita una recarga de TAE.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a03)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client_1");
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ViewPerson img={imgTema6.Yonny_saludo} />
					<DialogBarNew
						name='Yonny'
						dialog={`Buenas tardes, me gustaría obtener una recarga para mi celular.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a04)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¡Con todo gusto! ¿Sería tiempo aire o paquete?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Tiempo aire por favor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a06)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_desk_1");
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Veamos los pasos para realizar un cobro de Tiempo Aire.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a07)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "view_keyboard");
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Primer paso: Oprime la tecla "A" o selecciona la opción "Tiempo Aire" en la pantalla.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a08)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "hidden_keyboard");
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Segundo paso: Pregunta al Cliente la "Compañía telefónica".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a09)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "view_money");
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Tercer paso: Pregunta al Cliente "El monto que le recargará, subtotaliza y realiza el cobro".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a10)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "hidden_money");
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Cuarto paso: Captura el "Número de teléfono y verifícalo con el Cliente”.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act1_a11)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
						<div className='w-[200px] md:w-[500px]'>
							<img className='h-full w-full object-contain' src={imgTema6.Ticket} alt="ticket" />
						</div>
					</div>
					<DialogBarNew
						dialog={`Quinto paso: "Entrega el Ticket" y agradece al Cliente por su visita.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Así es el deber ser del proceso de cobro para TAE."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema6.activities.subtema2
								})
							);
							navigator("/home6/tema6/subtema2/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}


const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}